import confetti from "canvas-confetti";
import { toast } from "sonner";
import { api } from "./api";

export const celebrate = () => {
  confetti({ particleCount: 90, spread: 75, origin: { y: 0.7 }, colors: ["#2f6f4f", "#c99a2e", "#e8e0d0", "#c05b3c"] });
};

export const checkAchievements = async () => {
  try {
    const r = await api.get("/achievements");
    const fresh = r.data.filter((a) => a.new);
    if (fresh.length) {
      celebrate();
      fresh.forEach((a) => toast.success(`Achievement unlocked: ${a.title}!`, { duration: 6000 }));
    }
    return r.data;
  } catch { return []; }
};
